import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React, { RefObject } from 'react';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

export interface BoostInfoBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null>;
  title: string;
  body: string;
  primaryButton: {
    buttonText: string;
  };
  onSubmit: () => void;
  onDismiss: () => void;
}

const BoostInfoBottomSheet = ({
  bottomSheetRef,
  title,
  body,
  primaryButton,
  onSubmit,
  onDismiss,
}: BoostInfoBottomSheetProps) => {
  return (
    <BottomSheet
      ref={bottomSheetRef}
      onDismiss={onDismiss}
      contentContainerStyle={styles.container}
    >
      <View style={styles.illustration}>
        <Illustration illustration="GAUGE_D" />
      </View>

      <View style={styles.contentContainer}>
        {title ? (
          <TitleLgText style={styles.title} numberOfLines={0}>
            {title}
          </TitleLgText>
        ) : null}

        {body ? (
          <BodyBaseText style={styles.body} numberOfLines={0}>
            {body}
          </BodyBaseText>
        ) : null}
      </View>

      <View style={styles.buttonContainer}>
        {primaryButton ? (
          <Button
            onPress={onSubmit}
            label={primaryButton.buttonText}
            type="PRIMARY"
          />
        ) : null}
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    paddingTop: 0,
  },
  contentContainer: {
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing.m,
    paddingVertical: theme.spacing.m,
    paddingHorizontal: theme.spacing.l,
  },
  illustration: {
    width: 72,
    height: 72,
  },
  title: {
    textAlign: 'center',
  },
  body: {
    textAlign: 'center',
  },
  buttonContainer: {
    padding: theme.spacing.m,
    width: '100%',
  },
});

export default BoostInfoBottomSheet;
